import { ANIMATION_DURATION } from './config.js';

export function close_toast(elOrId) {
  return new Promise((resolve) => {
    let toast;

    if (elOrId instanceof $ || (elOrId && elOrId.jquery)) {
      toast = elOrId;
    } else if (elOrId instanceof Element) {
      toast = $(elOrId).closest('.maino-toast');
    } else if (typeof elOrId === 'string') {
      toast = $(`#alerts .maino-toast[data-toast-id="${elOrId}"]`);
    } else {
      toast = $('#alerts .maino-toast').last();
    }

    if (!toast.length) {
      resolve();
      return;
    }

    const timer = toast.data('timer');
    if (timer) {
      clearInterval(timer);
      toast.removeData('timer');
    }

    let finalizado = false;
    const finalizar = () => {
      if (finalizado) return;
      finalizado = true;
      toast.remove();
      resolve();
    };

    toast.on('transitionend', finalizar);
    setTimeout(finalizar, ANIMATION_DURATION);

    toast.addClass('maino-toast--saindo');
  });
}
